import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { useModal } from '../components/AppModal';

const ForgotPassword = () => {
  const modal = useModal();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      modal.error(err.response?.data?.message || 'Error solicitando recuperación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>CRM<span style={{ color: 'var(--accent)' }}>llor</span></h1>
        <p className="subtitle">Recuperar contraseña</p>
        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ marginBottom: 16 }}>
              Si <strong>{email}</strong> está dado de alta en el sistema, en unos segundos
              recibirás un email con un enlace para fijar una nueva contraseña.
            </p>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
              El enlace caduca en 1 hora.
            </p>
            <Link to="/login" className="btn btn-outline" style={{ width: '100%', justifyContent: 'center' }}>
              Volver al login
            </Link>
          </div>
        ) : (
          <>
            <p style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>
              Introduce tu email. Si está registrado, te enviaremos un enlace para
              fijar una nueva contraseña.
            </p>
            <form onSubmit={submit}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar enlace'}
              </button>
            </form>
            <div style={{ marginTop: 16, textAlign: 'center', fontSize: 13 }}>
              <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                Volver al login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
